import React from 'react'
import CourseCatalog from '../../features/CourseCatalogFeature'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { Box } from '@mui/material'

const Page = (): JSX.Element => {
  return (
    <React.Fragment>
      <Box display='flex' flexDirection='column' gap={6} >
        <CustomHeader title={PAGE_TITLES.COURSE_CATALOG} />
        <CourseCatalog />
      </Box>
    </React.Fragment>
  )
}

export default Page
